module.exports = __webpack_public_path__ + "static/img/y-1.cc47bab5.png";